const jobsCalendar = {
  view: 'Ver',
  calendarView: {
    monthly: 'Mensual',
    weekly: 'Semanal',
  },

  modalRemoveConfirm: {
    header: '¡Advertencia!',
    bodySingle: '¿Está seguro de que desea eliminar esta reserva?',
    bodyMultiple: '¿Está seguro de que desea eliminar estas reservas?',
    confirmBtn: 'Eliminar',
  },

  calendarTable: {
    actions: {
      delete: 'Eliminar'
    },
    cells: {
      dayOff: 'Día desactivado',
    },
    headers: {
      name: 'Nombre',
      monday: 'Lunes {{day}}',
      tuesday: 'Martes {{day}}',
      wednesday: 'Miércoles {{day}}',
      thursday: 'Jueves {{day}}',
      friday: 'Viernes {{day}}',
      saturday: 'Sábado {{day}}',
      sunday: 'Domingo {{day}}',
    },
  },

  filters: {
    students: 'Alumnos',
    caregivers: 'Cuidadores',
  }, 

  shiftsFilter:{
    all:'Todos los pasajeros',
    withShift: 'Pasajeros con Turnos',
    withoutShifts: 'Pasajeros sin turnos',
  },
};

export default jobsCalendar;